import React, { FC, ForwardedRef, forwardRef } from "react";

import { IconButton } from "../index";
import attentionIcon from "../../../resources/icons/attention.svg";

import styles from "./index.module.css";

type TextAreaProps = {
  label: string;
  error?: string;
};

const Textarea: FC<TextAreaProps> = forwardRef(
  (props: TextAreaProps, forwarded: ForwardedRef<HTMLTextAreaElement>) => {
    const { label, error, ...remainingProps } = props;

    const renderErrorMessage = error && (
      <div className={styles.errorContainer}>
        <IconButton icon={<img src={attentionIcon} alt="" />} tooltip={error} />
      </div>
    );

    return (
      <div className={styles.container}>
        <textarea
          ref={forwarded}
          placeholder={label}
          className={styles.textarea}
          {...remainingProps}
        />
        {renderErrorMessage}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export default Textarea;
